import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import installApiTracing from './utils/installApiTracing';
import { BASE_URL } from './configs/config';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || 'development',
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 0.2,
  });
}

installApiTracing({
  client_app: 'stadium-customer',
  client_version: process.env.REACT_APP_ENV || 'development',
  api_prefixes: [BASE_URL],
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
